export default __webpack_public_path__ + "0ca5dd2257ba14148f3b5b44534f6ecf.json";